import { ChapterColumnSEOWrapper } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/guidePages/components/ChapterColumnSEOWrapper";
import { ChaptersNavSection } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/guidePages/components/ChaptersNavSection";
import { GuideRowSection } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/guidePages/styles";
import { useGetActiveChapterHash } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/guidePages/useGetActiveChapterHash";
import { useGuideStore } from "@faire/retailer-visitor-shared/views/open-with-faire/academy/guidePages/useGuideStore";
import { getWindow } from "@faire/web--source/common/globals/getWindow";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import React, { useEffect, Suspense } from "react";
import styled from "styled-components";

export const GuideBodyRobots: React.FC = () => {
  const [{ guide }] = useGuideStore(["guide", "guideBackendData"]);
  const chapterHash = useGetActiveChapterHash();

  useEffect(() => {
    const chapterHashAdjusted = chapterHash.replace("#", "");
    getWindow()?.document.getElementById(chapterHashAdjusted)?.scrollIntoView();
  }, [chapterHash]);

  return (
    <>
      <GuideChaptersSection gap={{ tabletAndAbove: "10x", mobileAndAbove: 0 }}>
        <ChaptersNavSection
          guideTitle={guide.title}
          chapters={guide.chapters}
          readChapters={new Set()}
        />
        <ChapterColumnSEOWrapper>
          <Suspense fallback={null}>
            {guide.chapters.map((chapter) => {
              const ChapterComponent = chapter.ChapterComponent;
              return (
                <React.Fragment key={chapter.id}>
                  <div id={chapter.titleHash.replace("#", "")} />
                  <ChapterComponent />
                </React.Fragment>
              );
            })}
          </Suspense>
        </ChapterColumnSEOWrapper>
      </GuideChaptersSection>
    </>
  );
};

const GuideChaptersSection = styled(GuideRowSection)`
  padding-top: ${getSpacing("5x")};
  padding-bottom: ${getSpacing("5x")};

  ${responsiveMediaQueries.mobile} {
    flex-direction: column;
    padding-top: ${getSpacing("3x")};
    padding-bottom: ${getSpacing("3x")};
  }
`;
